'use client';

/**
 * @module
 * @category Component
 */

import 'BomdisoftComponents/detail-field/styles.css';
import { joinClasses } from 'BomdisoftComponents/html/index';
import { Tooltip } from 'BomdisoftComponents/tooltip/index';
import { editFieldT, getLanguageFromLocale } from '@bomdisoft/translations';
import { useParams } from 'next/navigation';
import { type MouseEvent, type ReactNode } from 'react';

interface DetailFieldProps {
  name: string;
  value?: string | number | null;
  child?: ReactNode;
  isEditable?: boolean;
  highlight?: boolean;
  inset?: boolean;
  valueClassName?: string;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
}

export const DetailField = ({ name, value = '', child = '', isEditable, highlight, inset, valueClassName, onClick = () => null }: DetailFieldProps) => {
  const params = useParams();
  const language = getLanguageFromLocale(typeof params?.lang === 'string' ? params.lang : undefined);

  return (
    <div className='bomdisoft-detail-field' data-highlight={highlight ? '' : undefined} data-inset={inset ? '' : undefined}>
      <p className='bomdisoft-detail-field-key'>{name}</p>
      {!child && (
        <div className={joinClasses('bomdisoft-detail-field-value', valueClassName)}>
          {value || value == 0 ? value : '-'}
          {isEditable && (
            <Tooltip title={editFieldT[language].replace('{name}', name)}>
              <button aria-label={editFieldT[language].replace('{name}', name)} className='bomdisoft-detail-field-edit' onClick={onClick} type='button'>
                <svg aria-hidden='true' fill='currentColor' height='14' viewBox='0 -960 960 960' width='14'>
                  <path d='M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z' />
                </svg>
              </button>
            </Tooltip>
          )}
        </div>
      )}
      {child}
    </div>
  );
};
